import React, { useMemo } from 'react';
import type { FC, ReactNode } from 'react';
import { useExit } from '@wix/cli-ui-kit';
import type { UserInfo } from '../schemas.js';
import { AuthContext } from '../context.js';
import { EnsureLoggedIn } from '../components/EnsureLoggedIn.js';
import { createSiteAuthStrategy } from '../auth-strategies/index.js';

interface Props {
  siteId: string;
  onError?: (error: unknown) => void;
  onLogin?: (userInfo: UserInfo) => void;
  children: ReactNode;
}

export const SiteAuthProvider: FC<Props> = ({
  children,
  siteId,
  onError,
  onLogin,
}) => {
  const exit = useExit();
  const authStrategy = useMemo(() => createSiteAuthStrategy(siteId), [siteId]);

  return (
    <EnsureLoggedIn
      authStrategy={authStrategy}
      onLogin={({ userInfo }) => onLogin?.(userInfo)}
      onError={onError ?? exit}
    >
      {({ getAccessToken, getRequestHeaders, userInfo }) => (
        <AuthContext.Provider
          value={{ getAccessToken, getRequestHeaders, userInfo }}
        >
          {children}
        </AuthContext.Provider>
      )}
    </EnsureLoggedIn>
  );
};
